export default __webpack_public_path__ + "static/media/Tejaswini.83e514db.jpg";